module.exports = __webpack_public_path__ + "static/media/gallery05.8ac388ac.png";